import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { TableInvoiceFields } from '../../../models/invoices';
import moment from 'moment';

@Component({
  selector: 'app-invoices-panel-modify-payment-date',
  standalone: true,
  imports: [
    MatDatepickerModule,
    MatCardModule,
    MatNativeDateModule,
    MatInputModule,
    FormsModule,
  ],
  templateUrl: './invoices-panel-modify-payment-date.component.html',
  styleUrl: './invoices-panel-modify-payment-date.component.scss',
})
export class InvoicesPanelModifyPaymentDateComponent implements OnInit {
  @Input() invoice!: TableInvoiceFields | null;
  @Output() closePanel = new EventEmitter<void>();
  @Output() confirmNewPaymentDate = new EventEmitter<string>();
  newPaymentDate: Date = new Date();

  ngOnInit(): void {
    if (this.invoice?.data_pagamento) {
      const [day, month, year] = this.invoice.data_pagamento
        .split('/')
        .map(Number);
      this.newPaymentDate = new Date(year, month - 1, day);
    }
  }

  close() {
    this.closePanel.emit();
  }

  confirm() {
    const formattedDate = moment(this.newPaymentDate).format('DD/MM/YYYY');
    this.confirmNewPaymentDate.emit(formattedDate);
  }
}
